import DetailLibrary from './DetailLibrary';

export default DetailLibrary;
